// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3IK7k","list":"BalanceDue_list__1wwJ1","listRow":"BalanceDue_listRow__3rQ1J","total":"BalanceDue_total__-eMum"};